export default __webpack_public_path__ + "static/media/Done.0110c1ff.svg";